<template>
	<FormGroupBox
		:icon="'manage_accounts'"
		:title="`Proveedor`"
		:class="`border-${getClass.class}`"
	>
		<b-form-row  v-if="$hasPermission('reservation.supplier.show')">
			<b-form-group class="col-md-6">
				<label>
					Confirmación
					<md-icon
						:icon="getClass.icon"
						:class="`text-${getClass.class}`"
					>
					</md-icon>
				</label>
				<b-form-select
					:disabled="unableEdit"
					size="sm"
					v-model="supplierConfirmation"
					:options="supplierConfirmationOpts"
				/>
				<div v-if="!$root.isEmpty(lastNotificationSupplier)">
					<small
						class="text-muted"
						v-b-tooltip.hover
						icon="event_available"
						:title="'Fecha y hora [America/Cancún] del último envio de notificación a proveedor ['+lastNotificationSupplier.type+']'"
						style='cursor:pointer'
						>
						<md-icon icon="mark_email_read"/> {{lastNotificationSupplier_date}} hrs.
					</small>
					<a href="#" @click="openMailEvents"><small style="font-size:65%">Ver eventos..</small></a>
				</div>

			</b-form-group>

			<b-form-group class="col-6">
				<b-button
					v-if="(id>0) && $hasPermission('reservation.supplier.assign.history')"
					size="sm"
					class="ml-2"
					v-b-tooltip.hover
					title="Historial de asignaciones "
					variant="outline-success"
					style="float:right"
					@click="showHistorySupplier"
				>
					<md-icon icon="timeline"></md-icon>
				</b-button>
				<b-button
					v-if="(id>0) && $hasPermission('reservation.tracking.show')"
					class="ml-2"
					size="sm"
					v-b-tooltip.hover
					title="Tracking"
					variant="outline-success"
					style="float:right"
					@click="showTrackingForm"
				>
					<md-icon icon="emoji_transportation"></md-icon>
				</b-button>

				<b-button
					v-if="(id>0) && $hasPermission('reservation.supplier.cost') && false"
					size="sm"
					class="ml-2"
					v-b-tooltip.hover
					title="Asignacion de proveedor"
					variant="outline-primary"
					style="float:right"
					@click="showSupplierCosts"
				>
					<md-icon icon="price_check"></md-icon>
				</b-button>

				<b-button
					v-if="(id>0) && $hasPermission('reservation.supplier.cost')"
					size="sm"
					class="ml-2"
					v-b-tooltip.hover
					title="Instrucciones de aeropuerto"
					variant="outline-primary"
					style="float:right"
					@click="showPdfModal"
				>
					<md-icon icon="hail"></md-icon>
				</b-button>
			</b-form-group>
		</b-form-row>
		<b-form-row  v-if="$hasPermission('reservation.supplier.show')">
			<b-form-group class="col-md-4" label="Proveedor">
				<b-form-select
					:disabled="true"
					size="sm"
					@change="onChangeSupplier"
					v-model="supplierId"
					:options="supplierOpts"
					required
				/>
				<small v-if="id>0" class="text-muted">
					<md-icon style="cursor:pointer" v-b-tooltip.hover icon="event_available" title="Fecha y hora de asignación"></md-icon> {{supplierAssignedAt_date}} hrs.
				</small>
			</b-form-group>
			<b-form-group class="col-md-4" label="Tipo de servicio">
				<b-form-input
					:disabled="true"
					type="text"
					size="sm"
					v-model="getServiceTypeName"
				/>
			</b-form-group>
			<b-form-group class="col-md-4" label="Referencia proveedor">
				<b-form-input
					:disabled="unableEdit"
					type="text"
					size="sm"
					v-model="supplierReference"
				/>
			</b-form-group>
		</b-form-row>
		<b-form-row >
			<b-form-group class="col-12" label="Notas para el proveedor">
				<b-textarea
					:disabled="unableEdit"
					size="sm"
					v-model="supplierNotes"
				/>
			</b-form-group>
		</b-form-row>
		<p class="m-0" >Estado de tracking: <strong>{{transportServiceTrackingStatus.text}}</strong></p>
		<b-modal
			hide-footer
			ref="supplier-history"
			size="xl"
			:title="`Historial`"
		>
			<HistorySupplierAssignation :transportServiceId="id" />
		</b-modal>
		<b-modal
			hide-footer
			ref="tracking-module"
			size="xl"
			:title="`Tracking del servicio`"
		>
			<TrackingServiceForm :index="index" />
		</b-modal>

		<b-modal
		hide-footer
		size="lg"
		ref="supplier-costs"
		title="Asignacion de proveedores"
		>
		<SupplierCosts
			:index="index"
			:transportServiceId="id"
			@getDataSupplier="getDataSupplier"
			:unableEdit=unableEdit
		/>
		</b-modal>

		<b-modal
			v-if="!$root.isEmpty(lastNotificationSupplier)"
			hide-footer
			size="xl"
			ref="mail-events-supplier"
			title="Eventos"
		>
			<MailEvents :messageId="messageId">
				<template v-slot:title>
					<h5>Ride #{{serviceNumber}}</h5>
				</template>
			</MailEvents>
		</b-modal>
		<!-- Modal to load and show the PDF -->
		<b-modal id="pdfModal" ref="pdfModal" size="lg" title="PDF Viewer" hide-footer dialog-class="sc-modal-xl">
			<iframe
				v-if="pdfUrl"
				:src="pdfUrl"
				width="100%"
				height="700px"
				frameborder="0"
			></iframe>
		</b-modal>
	</FormGroupBox>
</template>

<script>
import FormGroupBox from "@/components/helpers/FormGroupBox";
import { mapFields } from "../helpers/helpers";
import HistorySupplierAssignation from "../../../reservations/HistorySupplierAssignation";
import TrackingServiceForm from "../../../reservations/tracking/TrackingTransportServiceForm";
import SupplierCosts from "../helpers/_supplierCosts";
import moment from "moment";
import MailEvents from "../../../../helpers/ExternalMailEvents"
export default {
	props: {
		index: Number,
		unableEdit: Boolean,
		// serviceTypesOpts: Array
		// serviceTypesOpts:{
		// 	type: Array,// array con todos los tipos de servicios de proveedores
		// 	default:()=>{[{text:'', value:0}]}
		// }
	},
	components: {
		HistorySupplierAssignation,
		FormGroupBox,
		TrackingServiceForm,
		SupplierCosts,
		MailEvents
	},
	data(){
		return{
			itemSupplierServiceType:{},
			supplierServiceTypeName:'',
			pdfUrl:null
		}
	},
	mounted(){
		// this.getSupplierServiceTypeName();
	},
	beforeCreate() {
		this.$options.computed = {
			//El viewModel principal esta en el modulo reservation de vuex store
			...mapFields({
				fields: [
					"id",
					"supplierConfirmation",
					"supplier",
					"supplierId",
					"supplierServiceTypeId",
					"supplierServiceType",
					"supplierReference",
					"supplierNotes",
					"trackingStatus",
					"supplierAssignedAt",
					"lastNotificationSupplier",
					"serviceNumber"
				],
				fieldArray: "transportServices",
				index: this.$options.propsData.index,
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),
			...mapFields({
				fields: [
					"editToken",
				],
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),
			transportServiceTrackingStatus(){
				return this.$root.auxVars.transportServiceTrackingStatusOpts.find(opt => opt.value === this.trackingStatus)
			},
			supplierConfirmationOpts() {
				return this.$root.auxVars.supplierConfirmationOpts;
			},
			existSupplierIdIndAuxVars() {
				return this.$root.auxVars.suppliersOpts.find(
					st => st.value == this.supplierId
				);
			},
			supplierOpts() {
				if (
					this.supplierId !== -1 &&
					!this.existSupplierIdIndAuxVars
				) {
					return [
						{
							value: this.supplier.id,
							text: this.supplier.name
						},
						...this.$root.auxVars.suppliersOpts
					];
				}
				return this.$root.auxVars.suppliersOpts;
			},
			getClass() {
				switch (this.supplierConfirmation) {
					case "pending":
						return {
							icon: "warning",
							class: "warning"
						};
					case "confirmed":
						return {
							icon: "check_circle",
							class: "success"
						};
					case "rejected":
						return {
							icon: "dangerous",
							class: "danger"
						};
					default:
						return {
							icon: "",
							class: ""
						};
				}
			},
			serviceTypesOpts() {
				return this.$root.auxVars.serviceTypesOpts;
			},
			getServiceTypeName(){
				if(this.supplierServiceType) {
					return this.supplierServiceType.name
				}
				return "Indefinido"
			},
			supplierAssignedAt_date() {
				return moment(this.supplierAssignedAt).format("DD/MM/YYYY HH:mm");
			},
			lastNotificationSupplier_date() {
				return moment(this.lastNotificationSupplier.creationDatetime).format("DD/MMM/YYYY HH:mm");
			},
			messageId(){
				let messageId = null;
				try{
					if(!this.$root.isEmpty(this.lastNotificationSupplier)){
						messageId = this.lastNotificationSupplier.externalMessageId;
					}
				}catch(err){
					console.log(err);
				}
				return messageId;
			}
		}
	},
	methods: {
		getDataSupplier(supplierId, serviceTypeId, serviceName) {
			this.supplierServiceType.name = serviceName
			this.supplierId = supplierId
			this.supplierServiceTypeId = serviceTypeId;
			this.$refs["supplier-costs"].hide();
		},
		showHistorySupplier() {
			this.$refs["supplier-history"].show();
		},
		showTrackingForm() {
			this.$refs["tracking-module"].show();
		},
		showSupplierCosts() {
			this.$refs["supplier-costs"].show();
		},
		onChangeSupplier() {
			this.supplierConfirmation = "pending"
		},
		openMailEvents(){
			this.$refs["mail-events-supplier"].show()
		},
		showPdfModal() {
			let url = process.env.VUE_APP_API_URL;
			const parsedUrl = new URL(url);
			const host = parsedUrl.origin; // Returns protocol + host
			url = host + `/meeting/${this.id}/${this.editToken}`
			
			// Set your PDF URL dynamically or statically
			this.pdfUrl = url;
		
			// Show the modal
			this.$refs.pdfModal.show();
		},
	},
};
</script>
